var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-dropdown",
      class: {
        "app-dropdown--disabled": _vm.$attrs.disabled,
        "app-dropdown--error": _vm.hasError
      }
    },
    [
      _vm.$slots.default
        ? _c(
            "div",
            { staticClass: "app-dropdown__label" },
            [
              _vm.$attrs.required
                ? _c("span", { staticClass: "require-mark" }, [_vm._v("*")])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "app-dropdown__wrapper" }, [
        _c("div", { staticClass: "app-dropdown__toggle" }, [
          _c("input", {
            staticClass: "app-dropdown__hidden",
            attrs: { type: "text", required: _vm.$attrs.required },
            domProps: { value: _vm.hasValue ? 1 : "" },
            on: { invalid: _vm.setInvalidMessage }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "app-dropdown__selected",
              class: { vertical: _vm.position === "vertical" }
            },
            [
              [
                _vm.selected.length < 1
                  ? _c("div", {
                      staticClass: "app-dropdown__placeholder",
                      class: {
                        "app-dropdown__placeholder--empty": !_vm.$attrs
                          .placeholder
                      },
                      domProps: {
                        textContent: _vm._s(_vm.$attrs.placeholder || " ")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.selected, function(option, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _vm._t(
                        "selected",
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "app-dropdown__value app-dropdown__value--tag"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(option[_vm.displayProp] || option) +
                                  "\n\n\t\t\t\t\t\t\t\t\t"
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "app-dropdown__remove",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.remove(option)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t×\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        { props: { option: option, remove: _vm.remove } }
                      )
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search"
                    }
                  ],
                  staticClass: "app-dropdown__input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.search },
                  on: {
                    keypress: _vm.enter,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.search = $event.target.value
                    }
                  }
                })
              ]
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm.hasError
        ? _c("p", { staticClass: "app-dropdown__error" }, [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.invalidMessage || _vm.error) + "\n\t\t"
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ccbf522e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccbf522e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppMultipleTextField.vue
// module id = null
// module chunks = 